module.exports = __webpack_public_path__ + "static/img/cont21.6dcc626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/cont21.jpg
// module id = Ng9H
// module chunks = 1